import { appstr } from "../utils/appstr";
import { kAccountADPBasic } from "../constants";
import { GetUnknownErrorMessage } from "../utils/GetUnknownErrorMessage";
import { QAlert } from "./QAlert";
import { QDataRefreshRFC } from "./QDataRefreshRFC";
import { ValidateCreds } from "../utils/ValidateCreds";
import { Globals } from "./Globals";
export class QValidateCredsRFC extends QDataRefreshRFC {
  constructor() {
    super();
  }

  SetParams(orgName, userName, mode, data, chartID) {
    this.AddParameter("chartID", chartID);
    this.AddParameter("data", JSON.stringify(data));
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    if (callBackObj && Globals._wsMgr && Globals._wsMgr.fWaiting) {
      Globals._wsMgr.ClearAppLoadingAnimation();
    }
    Globals._timerMgr.ClearTimer();
    Globals._wsMgr.fWaiting = null;
    var p = JSON.parse(response);

    if (!p["success"]) {
      var alert = new QAlert();
      var isBasic = Globals._accountInfo.GetOC5Edition() === kAccountADPBasic;
      switch (p["code"]) {
        case "0001":
          var alertMessage = p["message"];
          break;
        case "0002":
          var alertMessage = appstr("Unhandled Validation");
          break;
        default:
          //Catch all for unhandled exceptions
          var alertMessage = isBasic ? appstr("unknownerrnoemail") : GetUnknownErrorMessage();
          break;
      }

      alert.InitCodeAlert(
        appstr("failedauth"),
        alertMessage,
        {
          ExecuteAlertCommand: () => {
            /* No-op */
          }
        },
        Globals._wsMgr,
        "DONOTHING",
        appstr("OK")
      );
    }

    callBackObj.HandleResponse(p);
    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();
  }
}
